import { Component, OnInit, PLATFORM_ID, Inject, Optional } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {RESPONSE} from '@nguniversal/express-engine/tokens';
import {Response} from 'express';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-page404',
  templateUrl: './page404.component.html',
  styleUrls: ['./page404.component.scss']
})
export class Page404Component implements OnInit {

  constructor(
    private _title: Title,
    private _meta: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(RESPONSE) private response: Response
  ) {
  }

  ngOnInit() {
    this._meta.updateTag({property: 'og:title', content: `404 - Strony nie znaleziono | Salon Expert L'Oréal Professionnel`});
    this._title.setTitle(`404 - Strony nie znaleziono | Salon Expert L'Oréal Professionnel`);

    if (!isPlatformBrowser(this.platformId)) {
      console.log(this.response);
      this.response.status(404);
    }
  }


}
